import { render, staticRenderFns } from "./ShopCurrency.vue?vue&type=template&id=7bca9d83&scoped=true"
import script from "./ShopCurrency.vue?vue&type=script&lang=js"
export * from "./ShopCurrency.vue?vue&type=script&lang=js"
import style0 from "./ShopCurrency.vue?vue&type=style&index=0&id=7bca9d83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bca9d83",
  null
  
)

export default component.exports